/**
 * Derive an ad-hoc thread title from its first user message: first line,
 * word-boundary truncated. No AI naming. Shared because the server persists
 * this title (chat/stream.ts) and the launcher header shows it optimistically
 * the moment the first send goes out — both sides must derive identically.
 */
export function deriveThreadTitle(text: string, maxLength = 60): string {
  const firstLine = text.trim().split("\n")[0]?.trim() ?? "";
  if (firstLine.length <= maxLength) return firstLine;
  const cut = firstLine.slice(0, maxLength);
  const lastSpace = cut.lastIndexOf(" ");
  return `${(lastSpace > 20 ? cut.slice(0, lastSpace) : cut).trimEnd()}…`;
}
